module.exports = __webpack_public_path__ + "img/en_US.1096139.webp";